var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#FFEBB7",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 19.9167H13.25C12.087 19.9167 11.5055 19.9167 11.0323 20.0602C9.967 20.3834 9.13333 21.217 8.81016 22.2824C8.66663 22.7555 8.66663 23.337 8.66663 24.5M19.0833 13.25C19.0833 15.3211 17.4044 17 15.3333 17C13.2622 17 11.5833 15.3211 11.5833 13.25C11.5833 11.1789 13.2622 9.5 15.3333 9.5C17.4044 9.5 19.0833 11.1789 19.0833 13.25ZM16.1666 24.5L18.7511 23.7616C18.8748 23.7262 18.9367 23.7085 18.9944 23.682C19.0457 23.6585 19.0944 23.6298 19.1399 23.5965C19.1911 23.5589 19.2366 23.5134 19.3276 23.4224L24.7083 18.0417C25.2836 17.4664 25.2836 16.5336 24.7083 15.9583C24.133 15.383 23.2003 15.383 22.625 15.9583L17.2443 21.339C17.1532 21.43 17.1077 21.4756 17.0702 21.5267C17.0368 21.5722 17.0081 21.6209 16.9846 21.6722C16.9581 21.7299 16.9404 21.7918 16.905 21.9155L16.1666 24.5Z",
    stroke: "#F2AE00",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarEdit);
export default __webpack_public_path__ + "static/media/avatarEdit.278cd13f2e440e5db503b96b381538a1.svg";
export { ForwardRef as ReactComponent };